import './App.scss';
import { BrowserRouter, Route, Switch, Link, useLocation, useHistory } from 'react-router-dom';
import NewHomePage from './components/NewHomePage/NewHomePage';
import Profile from './components/Profile/Profile';
import AProfile from './components/Profile/AProfile';
import ProfileModal from './components/ProfileModal/ProfileModal';
import Footer from './components/Footer/Footer';
import Navigation from './components/Navigation/Navigation';
import AboutPage from './components/AboutPage/AboutPage';
import MembersPage from './components/MembersPage/MembersPage';
import GalleryPage from './components/GalleryPage/GalleryPage';
import ContactPage from './components/ContactPage/ContactPage';
import RushPage from './components/RushPage/RushPage';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import AlumniPage from './components/AlumniPage/AlumniPage';
import { brothers } from './BrothersObjects';
import { Alum } from './BrothersObjects';
import getProfileSlug from './utils/getProfileSlug';

// for(const property in brothers[0])
//   console.log(brothers[0][property])

const memberSlug = (brother) => getProfileSlug(brother.name);
const alumSlug = (Alumni) => getProfileSlug(Alumni.name);

const profileRoutes = brothers.map((brother) => <Route exact sensitive path={"/members/" + memberSlug(brother)} render={(props) => <Profile {...props} brother={brother} />} key={brother.id} />);
const profileARoutes = Alum.map((Alumni) => <Route exact sensitive path={"/alumni/" + alumSlug(Alumni)} render={(props) => <AProfile {...props} Alumni={Alumni} />} key={Alumni.id} />);


function AppRoutes() {
  const location = useLocation();
  const history = useHistory();
  // Card links carry the roster location as state.background; when present,
  // the profile at the real URL renders as a modal over that background
  // instead of replacing it. Opening a modal pushes exactly one history
  // entry, so dismissal always goes back to it.
  const background = location.state && location.state.background;
  const backgroundScrollY = location.state && location.state.backgroundScrollY;
  const displayLocation = background || location;
  const closeModal = () => history.goBack();

  return (
    <>
      <div className="route-frame" key={displayLocation.pathname}>
        <Switch location={displayLocation}>
              <Route exact path="/" component={NewHomePage} />
              <Route exact sensitive path="/members" render={(props) => <MembersPage {...props} brothers={brothers} />} />
              {profileRoutes}
              <Route exact sensitive path="/alumni" render={(props) => <AlumniPage {...props} brothers={Alum} />} />
              {profileARoutes}
              <Route exact path="/about" component={AboutPage} />
              <Route exact path="/gallery" component={GalleryPage} />
              <Route exact path="/contact" component={ContactPage} />
              <Route exact path="/rush" component={RushPage} />
              <Route path="/" render={() => (
                <section className="not-found" aria-labelledby="not-found-heading">
                  <h1 id="not-found-heading" className="not-found__heading">404</h1>
                  <p className="not-found__copy">We couldn't find the page you were looking for.</p>
                  <Link to="/" className="btn btn--filled not-found__link">Return Home</Link>
                </section>
              )} />
        </Switch>
      </div>
      {background && (
        <>
          {brothers.map((brother) => {
            const headingId = `profile-modal-heading-member-${brother.id}`;
            return (
              <Route
                key={"modal-member-" + brother.id}
                exact
                sensitive
                path={"/members/" + memberSlug(brother)}
                children={({ match, ...routeProps }) => match ? (
                  <ProfileModal onClose={closeModal} labelledBy={headingId} backgroundScrollY={backgroundScrollY}>
                    <Profile {...routeProps} brother={brother} headingId={headingId} isModal />
                  </ProfileModal>
                ) : null}
              />
            );
          })}
          {Alum.map((Alumni) => {
            const headingId = `profile-modal-heading-alum-${Alumni.id}`;
            return (
              <Route
                key={"modal-alum-" + Alumni.id}
                exact
                sensitive
                path={"/alumni/" + alumSlug(Alumni)}
                children={({ match, ...routeProps }) => match ? (
                  <ProfileModal onClose={closeModal} labelledBy={headingId} backgroundScrollY={backgroundScrollY}>
                    <AProfile {...routeProps} Alumni={Alumni} headingId={headingId} isModal />
                  </ProfileModal>
                ) : null}
              />
            );
          })}
        </>
      )}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="site-shell">
        <a className="skip-link" href="#main-content">Skip to content</a>
        <Navigation />
        <main id="main-content" className="site-main" tabIndex="-1">
          <AppRoutes />
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;